var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.582 12.401-4.461.507c-.087.01-.148-.095-.109-.185l3.936-8.658A.107.107 0 0 1 11.043 4H15.9c.092 0 .144.12.087.206l-3.509 4.971c-.06.086 0 .216.096.206l4.305-.492c.1-.01.16.126.091.211L8.973 19.959c-.087.105-.23-.01-.178-.14l2.896-7.242c.035-.085-.026-.186-.109-.176Z",
    fill: "#222",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.68351d8e.svg";
export { ForwardRef as ReactComponent };